<template>
  <ion-page>
    <ion-content style="overflow: hidden !important">
      <Suspense>
        <template #default>
          <web-view :url="url" :query-string="queryString" />
        </template>
        <template #fallback>
          Wird geladen...
        </template>
      </Suspense>
    </ion-content>
  </ion-page>
</template>

<script lang="js">
import {
  IonPage,
  IonContent,
} from '@ionic/vue';
import {defineComponent, onMounted, onUnmounted} from 'vue';
import WebView from '@/components/WebView.vue'
import {useRoute} from "vue-router";
import {StatusBar} from "@capacitor/status-bar";
import {Capacitor} from "@capacitor/core";

export default defineComponent({
  setup() {
    const route = useRoute()
    const queryString = route.query
    const url = `${process.env.VUE_APP_COCKPIT_URL}`

    const cloundApiUrl = localStorage.getItem('cloudApiUrl')
    if (cloundApiUrl) {
        queryString.cloudApiUrl = cloundApiUrl
    }

    onMounted(async () => {
      if (Capacitor.getPlatform() !== 'web') {
        await StatusBar.setOverlaysWebView({overlay: true});
      }
    })

    onUnmounted(() => {
      window.history.replaceState({}, '', location.pathname);
    })

    return { queryString, url }
  },
  components: {
    IonPage,
    IonContent,
    WebView,
  }
});
</script>
